import { DoneAll } from '@mui/icons-material';
import { Box } from '@mui/system';
import React from 'react';
import ProgressIcon from './ProgressIcon';

export default function StoryProgressOverall(props) {
   
    let falsePaths = props.n_done;
    if (props.foundBestPath) falsePaths -= 1;
    const n_paths = props.n_paths;

    const finished = falsePaths >= n_paths && props.foundBestPath;

    return(
        <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-evenly"}}>
            <ProgressIcon correctpath={props.foundBestPath} falsepaths={falsePaths} n_paths={n_paths}
                sx={{fontSize: "10em"}}
            />
            {
                finished &&
                <DoneAll color="success" sx={{ml: 2}}/>
            }
        </Box>

    )
}